// Bump this when releasing the admin portal. Surfaced in the footer.
export const APP_VERSION = "1.0.0";
export const APP_NAME = "Hormuud SMS Gateway";
